import { Grid, Stack, Skeleton } from '@mui/material'
import React from 'react'

function TemplateFormHeaderSkeleton() {
  return (
    <>
      <Stack component="div" flexDirection="row" width="70%" justifyContent="end">
        <Grid container height={50} width={120} ml="1rem">
          <Skeleton height="100%" width="100%" />
        </Grid>
        <Grid container height={50} width={120} ml="auto">
          <Skeleton height="100%" width="100%" />
        </Grid>
      </Stack>
      <Stack component="div" flexDirection="row" gap={2} ml="auto" width="30%" justifyContent="end">
        <Grid container height={50} width={80}>
          <Skeleton height="100%" width="100%" />
        </Grid>
        <Grid container height={50} width={80}>
          <Skeleton height="100%" width="100%" />
        </Grid>
      </Stack>
    </>
  )
}

export default TemplateFormHeaderSkeleton
